<template>
    <div style="margin: 10px">
        <v-card>
            <v-toolbar color="primary" dark v-if="!print">
                <v-toolbar-title>{{$t(formName)}}</v-toolbar-title>
            </v-toolbar>
            <form v-if="!print">
                <v-layout wrap>
                    <v-flex xs12 sm12 md4 lg4 xl4 style="padding: 10px">
                        <v-select :label="$t('lang.area.name')"
                                  v-model.trim="search.areaId"
                                  v-validate="'required'"
                                  :items="lstArea"
                                  item-text="categoryName"
                                  item-value="categoryId"
                                  @change="getPondSearchList"
                                  clearable
                        />
                    </v-flex>
                    <v-flex xs12 sm12 md4 lg4 xl4 style="padding: 10px">
                        <v-select :label="$t('lang.pond.name')"
                                  v-model.trim="search.pondId"
                                  :items="lstPond"
                                  item-text="code"
                                  item-value="pondId"
                                  @change="getCropSearchList"
                                  clearable
                        />
                    </v-flex>
                  <v-flex xs12 sm12 md4 lg4 xl4 style="padding: 10px">
                    <v-select
                        :label="$t('lang.crop.cropNo')"
                        v-model.trim="search.cropNo"
                        v-validate="'required'"
                        :items="lstCropNo"
                        item-text="value"
                        item-value="id"
                        @change="getCropSearchList"
                        clearable
                        multiple
                    />
                  </v-flex>
                </v-layout>
                <v-layout wrap>
                    <v-flex xs12 sm12 md4 lg4 xl4 style="padding: 10px">
                      <v-select :label="$t('lang.crop.year')"
                                v-model.trim="search.year"
                                v-validate="'required'"
                                :items="lstYear"
                                item-text="categoryName"
                                item-value="categoryId"
                                @change="getCropSearchList"
                                clearable
                      />
                    </v-flex>
                  <v-flex xs12 sm12 md4 lg4 xl4 style="padding: 10px">
                        <i-datepicker :label="$t('lang.common.fromDate')"
                                      v-model="search.fromDate"
                                      v-validate="'date_before_now'"
                                      :data-vv-as="$t('lang.common.fromDate')"
                                      name="fromDate"
                                      :maxDate="maxDay()"
                                      :error-messages="errors.first('fromDate')"
                        />
                    </v-flex>
                  <v-flex xs12 sm12 md4 lg4 xl4 style="padding: 10px">
                        <i-datepicker
                                :label="$t('lang.common.toDate')"
                                v-model="search.toDate"
                                v-validate="'date_before_now'"
                                :data-vv-as="$t('lang.common.toDate')"
                                name="toDate"
                                :maxDate="maxDay()"
                                :error-messages="errors.first('toDate')"
                        />
                    </v-flex>
                    <v-flex xs12 sm12 md4 lg4 xl4 style="padding: 10px">
                        <v-autocomplete
                            :items="lstAssetsName"
                            :label="$t('Tên tài sản')"
                            v-model="search.assetsNameId"
                            item-value="categoryId"
                            item-text="categoryName"
                            clearable
                        />
                    </v-flex>
                </v-layout>
            </form>
            <table v-else class="infomation infoTable">
                <tr>
                    <td colspan="2" style="text-align: center;width: 100%" class="title">BÁO CÁO SỬ DỤNG VẬT TƯ</td>
                </tr>
                <tr>
                    <td><label>Từ ngày:</label> {{search.fromDate | formatDate}}</td>
                    <td><label>Đến ngày:</label> {{search.toDate | formatDate}}</td>
                </tr>
            </table>
            <v-card-text>
                <v-tabs v-if="cropSelected.length >0 ">
                    <v-tabs-slider color="#2196F3"></v-tabs-slider>
                    <v-tab
                            v-for="item in cropSelected"
                            :key="item.cropId"
                    >
                        {{item.name }}
                    </v-tab>
                    <v-tabs-items>
                        <v-tab-item v-for="item in cropSelected" :key="item.cropId">
                            <material-report-summary :report-data="reportData" :search="search" v-if="item.cropId == 0" ref="summary" @finishCalculate="finishCalculate"/>
                            <material-report-item :crop="item" :search="search" v-else @update="updateFromTab" />
                        </v-tab-item>
                    </v-tabs-items>
                </v-tabs>
            </v-card-text>
            <v-card-actions v-if="!print">
                <v-spacer/>

                <v-btn color="primary" @click="onPrint">
                    {{ $t("lang.report.print") }}
                </v-btn>
                <v-btn color="info" @click="onSend">
                    {{ $t("lang.report.send") }}
                </v-btn>
            </v-card-actions>
        </v-card>
        <send-report ref="sendDlg" @send="onSendTo"/>
    </div>
</template>

<script>
    import axios from "axios";
    import {message} from "../../shared/message";
    import moment from "moment";
    import MaterialReportItem from "./MaterialReportItem";
    import MaterialReportSummary from "./MaterialReportSummary";
    import SendReport from "./SendReport";
    import {Validator} from "vee-validate";

    export default {
        name: "material-report",
        components: {SendReport, MaterialReportSummary, MaterialReportItem},
        data: () => {
            return {
                formName: "Báo cáo sử dụng vật tư",
                lstPond: [],
                lstPondDefault: [{"pondId":-1, "code":"Tất cả"}],
                lstArea: [],
                lstCrop: [],
                lstYearDefault: [{"categoryId":-1, "categoryName":"Tất cả"}],
                lstYear:[],
                lstCropNo:[{id: 1, value: 1},{id: 2, value: 2},{id: 3, value: 3},{id: 3, value: 3},{id: 4, value: 4},{id: 5, value: 5}],
                cropSelected:[],
                cropSelectedDefault :[{cropId:0,name:"Tổng hợp"}],
                lstItem: [],
                search: {
                    fromDate: new Date(new Date().getFullYear(), 0, 1),
                    toDate: new Date(),
                    year: -1,
                    pondId: -1,
                    assetsNameId: -1,
                },
                print:false,
                g: null,
                reportData:{},
                saveSession:new Date().getTime(),
                flagCalculate:0,
                lstAssetsName: [],
            };
        },

        mounted(){
            Validator.extend("endDateAfterStart", {
                validate: (value, {otherValue}) => {
                    let mm = moment(value).hour(23).minute(59).second(59);
                    let valid = mm.isSameOrAfter(this.search.fromDate); // false
                    return {
                        valid: valid,
                        data: {
                            message: "Đến ngày phải sau Từ ngày"
                        }
                    };
                    ;
                },
                getMessage: (field, params, data) => {
                    return "Đến ngày phải sau Từ ngày";
                }
            });
        },

        created() {
            this.getArea();
            this.getYearList();
            if (this.$route.params.print != undefined) {
                this.print = true;
                this.search.areaId = parseInt(this.$route.params.areaId);
                // if (this.$route.params.pondId == undefined || this.$route.params.pondId == null || this.$route.params.pondId == "" || this.$route.params.pondId == "undefined") {
                //     this.search.pondId = null;
                // } else {
                //     this.search.pondId = JSON.parse(this.$route.params.pondId);
                // }
                // if (this.$route.params.cropId == undefined || this.$route.params.cropId == null || this.$route.params.cropId == "" || this.$route.params.cropId == "undefined") {
                //     this.search.cropId = null;
                // } else {
                //     this.search.cropId = JSON.parse(this.$route.params.cropId);
                // }

                if(!this.isNullOrEmpty(this.$route.params.pondId)){
                  this.search.pondId = this.$route.params.pondId;
                }
                if(!this.isNullOrEmpty(this.$route.params.cropNo)){
                  this.search.cropNo = JSON.parse(this.$route.params.cropNo);
                }
                if(!this.isNullOrEmpty(this.$route.params.year)){
                  this.search.year = this.$route.params.year;
                }
                this.search.fromDate = this.$route.params.fromDate;
                this.search.toDate = this.$route.params.toDate;
                this.getPondSearchList();
            }
            this.getAssetsName();
        },

        methods: {
            maxDay(){
                let day = moment().format("YYYY-MM-DD");
                // console.log(day);
                return day;
            },

            getArea() {
                axios.post(
                    process.env.VUE_APP_API_URL + "/category/myArea"
                ).then(
                    (data) => {
                        if (data.length > 0) {
                            this.lstArea = data;
                        }
                    }
                );
            },
            getYearList(){
              let url = process.env.VUE_APP_API_URL + "/selectboxdata/listYearLast5";
              axios.get(url).then((data) =>{
                if (data.count > 0) {
                  this.lstYear = this.lstYearDefault.slice();
                  this.lstYear.push(...data.items);
                }
              })
            },

            getPondSearchList() {
                this.search.cropId =[];
                //this.search.pondId = -1;
                axios.post(
                    process.env.VUE_APP_API_URL + "/pond/search?&pageSize=-1&page=1", {areaId: this.search.areaId}
                ).then(
                    (data) => {
                      this.lstPond = this.lstPondDefault.slice();
                      this.lstPond.push(...data.items);

                      this.getCropSearchList();
                    }
                );

            },

            getCropSearchList() {
                if(this.search.areaId == undefined){
                  return
                }

                if(this.search.pondId == undefined){
                  return
                }
                 if(this.search.cropNo == undefined || this.search.cropNo.length==0){
                  this.cropSelected = this.cropSelectedDefault.slice();
                  this.reloadTab();
                  return
                }

                let ob = {
                    pondAreaId: this.search.areaId,
                    pondParentId: this.search.pondId,
                    cropNos: JSON.stringify(this.search.cropNo),
                    year: this.search.year,
                }
                if(ob.cropNos == undefined || ob.cropNos.length == 0){
                  alert("Chưa chọn thứ tự vụ")
                  return;
                }
                let url = process.env.VUE_APP_API_URL + "/crop/search?pageSize=-1&page=-1&orderBy=asc";
                axios.post(url, ob).then((data) => {
                    this.lstCrop = data.items;
                    this.cropSelected = this.cropSelectedDefault.slice()
                    this.cropSelected.push(...data.items);
                    this.reloadTab();
                });
            },

            reloadTab(){
              for(let key in this.reportData){
                let bHas =false;
                if(this.search.cropSelected == undefined){
                  bHas = false;
                } else{
                  for(let i=1;i<this.search.cropSelected.length;i++){
                    if(key == this.search.cropSelected[i].cropId){
                      bHas = true;
                    }
                  }
                }

                if(!bHas){
                  delete this.reportData[key];
                }
              }
              console.log("this.reportData", this.reportData);
              if (this.$refs.summary != undefined && this.$refs.summary[0] != undefined) {
                this.$refs.summary[0].calculateData();
              }
              
            },
            finishCalculate(){
              if (this.print) {
                if(this.flagCalculate == this.cropSelected.length - 2){
                  this.$nextTick(
                      () => {
                        window.print();
                      }
                  )
                }

              }
            },

            updateFromTab(tabData){
                this.reportData[tabData.crop.cropId] = tabData;
                this.$refs.summary[0].calculateData();
                this.flagCalculate++;
            },

            onSend(){
                this.$refs.sendDlg.onShow();
            },

            generateReportURL(){
                let url = "/print/materialReport/1/";
                url += this.search.areaId + "/";
                url += JSON.stringify(this.search.pondId) + "/";
                let cropNo = JSON.stringify(this.search.cropNo);
                url += cropNo + "/";
                url += this.search.year + "/";
                url += this.search.fromDate + "/";
                url += this.search.toDate + "/";
                return url;
            },

            onSendTo(user) {
                console.log('--- send to user');
                console.log(user);
                let url =process.env.VUE_APP_FRONTEND_URL+"/#"+ this.generateReportURL();
                let report = {
                    reportType:'Báo cáo sử dụng vật tư',
                    userId:user.userId,
                    url:url
                };
                axios.post(process.env.VUE_APP_API_URL+"/report/sendReport",report).then(
                    data=>{
                        if(data.success){
                            message.success("Gửi thành công");
                            this.$refs.sendDlg.onCancel();
                        } else {
                            message.error("Gửi không thành công");
                        }
                    }
                );
            },

            onPrint() {
                let url = this.generateReportURL();
                this.$router.push(url);
            },

            getAssetsName() {
                axios.post(
                    process.env.VUE_APP_API_URL + "/category/onSearchAllStatus?categoryTypeCode=ASSETS_NAME&pageSize=-1&page=-1",
                    {}
                )
                .then((data) => {
                    if (data.items) {
                        this.lstAssetsName = data.items;
                    }
                });
            },
        },

        destroyed() {
        },
    };
</script>